import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import type { UpdateLotSizingPurchaseOrderLineInput } from '@/features/lot-sizing/lot-sizing-purchase-order-draft';
import { GET_LOT_SIZING_KEY, GET_LOT_SIZING_LINES_KEY } from '@/keys';

export type UpdateLotSizingPurchaseOrderLinesParams = {
  lotSizingId: string;
  lines: UpdateLotSizingPurchaseOrderLineInput[];
};

const updateLotSizingPurchaseOrderLines = async ({
  lotSizingId,
  lines,
}: UpdateLotSizingPurchaseOrderLinesParams): Promise<void> => {
  await api.patch(`/lot-sizings/${lotSizingId}/purchase-order-lines`, {
    lines,
  });
};

export function useUpdateLotSizingPurchaseOrderLines(): UseMutationResult<
  void,
  Error,
  UpdateLotSizingPurchaseOrderLinesParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateLotSizingPurchaseOrderLines,
    onSuccess: async (_, { lotSizingId }) => {
      await queryClient.refetchQueries({
        queryKey: [...GET_LOT_SIZING_KEY, lotSizingId],
      });
      await queryClient.invalidateQueries({
        queryKey: [...GET_LOT_SIZING_LINES_KEY, lotSizingId],
      });
    },
  });
}
